var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-5" },
    [
      (_vm.module_type_enabled &&
        (_vm.module_type == "module_9" ||
          _vm.module_type == "module_5_2" ||
          _vm.module_type == "module_5_3" ||
          _vm.module_type == "module_6" ||
          _vm.module_type == "module_17")) ||
      _vm.frontend_view_folder === "frontend.skigd"
        ? _c("h2", { staticClass: "text-center" }, [
            _vm._v("Welcome to " + _vm._s(_vm.site_name))
          ])
        : _vm._e(),
      _vm._v(" "),
      (_vm.module_type_enabled &&
        (_vm.module_type == "module_9" ||
          _vm.module_type == "module_5_2" ||
          _vm.module_type == "module_5_3" ||
          _vm.module_type == "module_6" ||
          _vm.module_type == "module_17")) ||
      _vm.frontend_view_folder === "frontend.skigd"
        ? _c("h4", { staticClass: "text-center" }, [
            _vm._v("Ready to rent skis and snowboards?")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.module_type_enabled && _vm.module_type == "module_9"
        ? _c(
            "v-row",
            { staticClass: "justify-center mt-10" },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "error mr-15" },
                  on: {
                    click: function($event) {
                      return _vm.reservationType("multiday")
                    }
                  }
                },
                [_vm._v("\n            Daily Reservation\n        ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { color: "error" }, on: { click: _vm.openModal } },
                [_vm._v("\n            1/2 Day / Night Skiing\n        ")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.module_type_enabled && _vm.module_type == "module_5_3"
        ? _c(
            "v-row",
            { staticClass: "justify-center mt-10" },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "error mr-15" },
                  on: {
                    click: function($event) {
                      return _vm.reservationType("multiday")
                    }
                  }
                },
                [_vm._v("\n            Daily / Multiday\n        ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { color: "error" }, on: { click: _vm.setHalfDay } },
                [_vm._v("\n            1/2 Day\n        ")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.module_type_enabled && _vm.module_type == "module_18"
        ? _c(
            "v-row",
            { staticClass: "justify-center mt-10" },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "error mr-15" },
                  on: {
                    click: function($event) {
                      return _vm.reservationType("multiday")
                    }
                  }
                },
                [_vm._v("\n            Daily Reservation\n        ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "error" },
                  on: {
                    click: function($event) {
                      return _vm.reservationType("night")
                    }
                  }
                },
                [_vm._v("\n            Night Skiing\n        ")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.frontend_view_folder === "frontend.skigd"
        ? _c(
            "v-row",
            { staticClass: "justify-center mt-10" },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "error mr-15" },
                  on: {
                    click: function($event) {
                      return _vm.reservationType("multiday")
                    }
                  }
                },
                [_vm._v("\n            Daily / Multiday\n        ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { color: "error" }, on: { click: _vm.openModal } },
                [_vm._v("\n            Afternoon / Night Skiing\n        ")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.module_type_enabled &&
      _vm.module_type !== "module_9" && _vm.module_type == "module_6"
        ? _c(
            "v-row",
            { staticClass: "justify-center mt-10" },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "error mr-15" },
                  on: {
                    click: function($event) {
                      return _vm.reservationType("multiday")
                    }
                  }
                },
                [_vm._v("\n            Multi day Reservation\n        ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "error mr-15" },
                  on: {
                    click: function($event) {
                      return _vm.reservationType("day_hours")
                    }
                  }
                },
                [_vm._v("\n            Day Skiing (9am-4pm)\n        ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "error" },
                  on: {
                    click: function($event) {
                      return _vm.reservationType("night_hours")
                    }
                  }
                },
                [_vm._v("\n            Night Skiing (4pm-9pm)\n        ")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.module_type_enabled && _vm.module_type == "module_5_2"
        ? _c(
            "v-row",
            { staticClass: "justify-center mt-10" },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "error mr-15" },
                  on: {
                    click: function($event) {
                      return _vm.reservationType("multiday")
                    }
                  }
                },
                [_vm._v("\n            Daily / Multiday\n        ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "error" },
                  on: {
                    click: function($event) {
                      return _vm.reservationType("afternoon")
                    }
                  }
                },
                [_vm._v("\n            1/2 Day\n        ")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.module_type_enabled && _vm.module_type == "module_17"
        ? _c(
            "v-row",
            { staticClass: "justify-center mt-10" },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "error mr-15" },
                  on: {
                    click: function($event) {
                      return _vm.reservationType("multiday")
                    }
                  }
                },
                [_vm._v("\n            Daily / Multiday\n        ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "error" },
                  on: {
                    click: function($event) {
                      return _vm.reservationType("night")
                    }
                  }
                },
                [_vm._v("\n            Night Skiing\n        ")]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }